import { render, staticRenderFns } from "./CreateAggregatedReportModal.vue?vue&type=template&id=60f07ff6&scoped=true"
import script from "./CreateAggregatedReportModal.vue?vue&type=script&lang=ts"
export * from "./CreateAggregatedReportModal.vue?vue&type=script&lang=ts"
import style0 from "./CreateAggregatedReportModal.vue?vue&type=style&index=0&id=60f07ff6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f07ff6",
  null
  
)

export default component.exports